import * as PriorityBoardingPopup from './components/PriorityBoardingPopup.css';

export default {
	PriorityBoardingPopup
};
